import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCheck10 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 82,
	height: 114,
	fill: "none",
	viewBox: "0 0 82 114",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillRule: "evenodd",
		stroke: "#00ABFF",
		strokeWidth: .75,
		d: "M79.272 1H2.728c-.476 0-.91.194-1.221.507C1.194 1.82 1 2.252 1 2.73v108.54c0 .477.194.91.507 1.223.312.313.743.507 1.221.507h76.544c.476 0 .91-.194 1.221-.507.314-.313.507-.746.507-1.223V2.73c0-.477-.194-.91-.507-1.223-.312-.313-.745-.507-1.221-.507z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#00ABFF",
		stroke: "#00ABFF",
		d: "M6.108 14.660h7.774v9.880h-7.774v-9.880zM17.075 14.660h7.772v.087h-7.772v-.087zM17.075 17.923h18.74v.088h-18.74v-.088zM47.780 14.660h7.774v9.880h-7.774v-9.880zM58.745 14.660h7.772v.087h-7.772v-.087zM58.745 17.923h18.74v.088h-18.74v-.088zM6.108 33.860h7.774v9.880h-7.774v-9.880zM17.075 33.860h7.772v.087h-7.772v-.087zM17.075 37.123h18.74v.088h-18.74v-.088zM47.780 33.860h7.774v9.880h-7.774v-9.880zM58.745 33.860h7.772v.087h-7.772v-.087zM58.745 37.123h18.74v.088h-18.74v-.088zM6.108 53.060h7.774v9.880h-7.774v-9.880zM17.075 53.060h7.772v.087h-7.772v-.087zM17.075 56.323h18.74v.088h-18.74v-.088zM47.780 53.060h7.774v9.880h-7.774v-9.880zM58.745 53.060h7.772v.087h-7.772v-.087zM58.745 56.323h18.74v.088h-18.74v-.088zM6.108 72.260h7.774v9.880h-7.774v-9.880zM17.075 72.260h7.772v.087h-7.772v-.087zM17.075 75.523h18.74v.088h-18.74v-.088zM47.780 72.260h7.774v9.880h-7.774v-9.880zM58.745 72.260h7.772v.087h-7.772v-.087zM58.745 75.523h18.74v.088h-18.74v-.088zM6.108 91.460h7.774v9.880h-7.774v-9.880zM17.075 91.460h7.772v.087h-7.772v-.087zM17.075 94.723h18.74v.088h-18.74v-.088zM47.780 91.460h7.774v9.880h-7.774v-9.880zM58.745 91.460h7.772v.087h-7.772v-.087zM58.745 94.723h18.74v.088h-18.74v-.088z"
	})]
});
export default SvgCheck10;
